import { router, useForm } from "@inertiajs/react";
import { useConfirmDialog } from "@/components/confirm-dialog-provider";
import { ProductShowLayout, ProductShowPage } from "@/pages/products/product-show-view";
import ManageStepCreateDrawer from "@/pages/manage/products/manage-step-create-drawer";
import {
  duplicate_manage_product_path,
  export_manage_product_path,
  edit_manage_product_step_path,
  manage_product_path,
  manage_product_step_path,
  manage_products_path,
  manage_product_steps_path
} from "@/routes";

function ManageShowProduct({ product, onCreateStep = null, onEditStep = null, onEditProduct = null }) {
  return (
    <ProductShowPage
      product={product}
      stepHrefBuilder={() => null}
      editStepHrefBuilder={(currentProduct, step) => edit_manage_product_step_path(currentProduct.id, step.id)}
      knowledgeFilesManage
      usesTemplateTerminology
      onCreateStep={onCreateStep}
      onEditStep={onEditStep}
      onEditProduct={onEditProduct}
    />
  );
}

function ManageShowProductLayout({ page }) {
  const { product } = page.props;
  const { confirm } = useConfirmDialog();
  const { post: duplicateProduct, processing: isDuplicating } = useForm({});

  return (
    <ProductShowLayout
      page={page}
      breadcrumbs={[
        { label: "Administration", href: manage_products_path() },
        { label: "Alle produkter", href: manage_products_path() },
        { label: product.name }
      ]}
      updatePath={(currentProduct) => manage_product_path(currentProduct.id)}
      createStepPath={(currentProduct) => manage_product_steps_path(currentProduct.id)}
      editStepPath={(currentProduct, step) => manage_product_step_path(currentProduct.id, step.id)}
      StepCreateDrawerComponent={ManageStepCreateDrawer}
      actions={({ product: currentProduct, canEditProduct, openEdit, openCreateStep }) => [
        {
          href: manage_products_path(),
          label: "Tilbage",
          variant: "outline-secondary"
        },
        ...(canEditProduct ? [
          {
            label: "Tilføj trin",
            variant: "outline-primary",
            onClick: openCreateStep
          },
          {
            label: "Redigér",
            variant: "primary",
            onClick: openEdit
          },
          {
            label: "Duplikér",
            variant: "outline-primary",
            disabled: isDuplicating,
            onClick: () => duplicateProduct(duplicate_manage_product_path(currentProduct.id))
          },
          {
            label: "Eksportér JSON",
            variant: "outline-primary",
            href: export_manage_product_path(currentProduct.id),
            download: true
          },
          {
            label: "Slet",
            variant: "danger",
            onClick: async () => {
              const confirmed = await confirm({
                title: "Slet produkt",
                description: `Vil du slette "${currentProduct.name}" fra det globale katalog?`,
                confirmLabel: "Slet",
                confirmVariant: "danger"
              });

              if (!confirmed) return;

              router.delete(`${manage_product_path(currentProduct.id)}?return_to=manage_index`);
            }
          }
        ] : [])
      ]}
    />
  );
}

ManageShowProduct.layout = (page) => <ManageShowProductLayout page={page} />;

export default ManageShowProduct;
